import { captureLoaded } from '../../../lib/funnels/functions/v1/metrics/captureLoaded.js'
import {
  initializeSession,
  populateStateOptions,
  setupGoogleMaps,
  setupAddressToggle,
  createProgressUpdater,
  createFrameTransition,
  setupInputListeners,
  setupContinueButtons,
  setupEnterKeyListeners,
  setupPreviousButtons,
  setupSidebarToggle,
  setupDisclaimerPopup,
  getFrameInfo,
  SESSION_ID,
  createFrameSubmitHandlerNDR,
} from '../shared.js'

import { getSessionValue } from '../../../lib/funnels/functions/v1/default/getSessionValue.js'
import { getFunnelCache } from '../../../lib/funnels/functions/v1/default/getFunnelCache.js'
import { leadDataToParam } from '@turbodebt/turbo-shared'
import { updateSession } from '../../../lib/funnels/functions/v1/default/updateSession.js'
import { submitSpinner } from '../../../lib/funnels/functions/v1/default/submitSpinner.js'
import { resetSubmitSpinner } from '../../../lib/funnels/functions/v1/default/resetSubmitSpinner.js'
import { submitForm } from '../../../lib/funnels/functions/v1/submit/submitForm.js'
import { stripPhone } from '../../../lib/funnels/functions/v1/default/stripPhone.js'
import { getTrustedFormFields } from '../../../lib/funnels/functions/v1/default/getTrustedFormFields.js'
import { submitSoftpull } from '../../../lib/funnels/functions/v1/submit/submitSoftpull.js'

import '../shared.css'
import './index.css'
import '../../styles/onboarding-savings-v-3-1-modal.css'
import { initAbandonModal } from '../../../lib/funnels/functions/v1/default/abandonmentModal.js'

document.addEventListener('DOMContentLoaded', () => {
  captureLoaded()

  // Initialize session data
  initializeSession()

  // Get DOM elements
  /** @type {HTMLElement | null} */
  const progressIndicator = document.querySelector('.progress-indicator')
  /** @type {HTMLElement | null} */
  const progressBarFill = document.querySelector('.progress-bar-fill')
  /** @type {HTMLElement | null} */
  const sidebarTarget = document.querySelector('.js-sidebar-target')
  /** @type {HTMLElement | null} */
  const sidebar = document.querySelector('.js-sidebar')
  /** @type {HTMLSelectElement | null} */
  const stateSelect = /** @type {HTMLSelectElement | null} */ (
    document.getElementById('state')
  )
  /** @type {HTMLElement | null} */
  const addressToggle = document.getElementById('toggleAddress')

  // Set up state options
  if (stateSelect) {
    populateStateOptions(stateSelect)
  }

  // Set up Google Maps
  setupGoogleMaps()

  // Set up address toggle
  if (addressToggle) {
    setupAddressToggle(addressToggle)
  }

  // function redirectIdleToChat() {
  //   const savedChatLink = getSessionValue(SESSION_ID, 'returnLink') || ''
  //   const loader = /** @type {HTMLElement | null} */ (
  //     document.querySelector('.td-loading-overlay')
  //   )
  //   if (savedChatLink && savedChatLink !== '') {
  //     if (loader) loader.style.display = 'flex'
  //     setTimeout(() => {
  //       window.location.href = savedChatLink // to chat
  //     }, 2000)
  //   }

  //   // submit tracking events?
  // }

  // Constants
  const frameInfo = getFrameInfo() // Get all frame info from HTML
  const totalFrames = frameInfo.questionFrames
  const loadingFrameNumber = frameInfo.loadingFrameNumber

  // Create progress updater (no OTP frame in savings-v3)
  const updateProgress = createProgressUpdater(
    progressIndicator,
    progressBarFill,
    totalFrames,
    loadingFrameNumber,
    null, // No OTP frame
  )

  /** IDLE DETECTION - Address Step (Frame 3) - DISABLED */
  // const IDLE_TIMEOUT = 30_000 // 30s
  // const step2El = /** @type {HTMLElement} */ (
  //   document.querySelector('[data-frame="3"]')
  // )

  // function isStep2Active() {
  //   return step2El && step2El.classList.contains('active')
  // }
  // /**
  //  * @type {string | number | NodeJS.Timeout | null | undefined}
  //  */
  // let idleTimer = null
  // function resetIdleTimer() {
  //   if (idleTimer) clearTimeout(idleTimer)
  //   if (isStep2Active()) {
  //     idleTimer = setTimeout(() => {
  //       redirectIdleToChat()
  //     }, IDLE_TIMEOUT)
  //   } else {
  //     idleTimer = null
  //   }
  // }

  // ;[
  //   'mousemove',
  //   'keydown',
  //   'scroll',
  //   'touchstart',
  //   'touchmove',
  //   'pointermove',
  // ].forEach((ev) =>
  //   window.addEventListener(ev, resetIdleTimer, { passive: true }),
  // )

  // const observer = new MutationObserver(resetIdleTimer)
  // if (step2El) {
  //   observer.observe(step2El, {
  //     attributes: true,
  //     attributeFilter: ['style', 'class'],
  //   })
  // }

  // Create form submit handler
  // const handleOnboardingSubmit = createFormSubmitHandler()

  // new last step form handler, prevent double calling this on frame transition
  let softpullTriggered = false
  async function handleSoftpullSubmit() {
    if (softpullTriggered) return

    softpullTriggered = true
    const savedChatLink = getSessionValue(SESSION_ID, 'returnLink') || ''
    const savedThanksUrl = getSessionValue(SESSION_ID, 'thanksUrl')

    const birthdateRaw = getSessionValue(SESSION_ID, 'birthdate').replace(
      /\D/g,
      '',
    )
    const birthdateFormatted = `${birthdateRaw.slice(4, 8)}-${birthdateRaw.slice(0, 2)}-${birthdateRaw.slice(2, 4)}`

    const softPullPayload = {
      dob: birthdateFormatted,
      city: getSessionValue(SESSION_ID, 'city'),
      state: getSessionValue(SESSION_ID, 'state'),
      postal_code: getSessionValue(SESSION_ID, 'zipcode'),
      address: getSessionValue(SESSION_ID, 'addressLine'),
      phone: getSessionValue(SESSION_ID, 'phone'),
    }

    await submitSoftpull(
      softPullPayload,
      savedChatLink,
      savedThanksUrl || '',
      SESSION_ID,
    )
  }

  const step3Button = document.getElementById('button-step3')
  const nameInput = /** @type {HTMLInputElement | null} */ (
    document.getElementById('name')
  )
  const emailInput = /** @type {HTMLInputElement | null} */ (
    document.getElementById('email')
  )
  const phoneInput = /** @type {HTMLInputElement | null} */ (
    document.getElementById('phone')
  )

  if (step3Button) {
    step3Button.addEventListener('click', async function () {
      if (
        !step3Button.classList.contains('valid') ||
        !nameInput ||
        !emailInput ||
        !phoneInput
      ) {
        return
      }

      let xxTrustedFormCertUrl = ''
      try {
        const trustedFormData = getTrustedFormFields('onboarding-form')
        xxTrustedFormCertUrl = trustedFormData.xxTrustedFormCertUrl || ''
      } catch {
        console.warn('TrustedForm fields not found')
      }

      const payload = {
        debtOwed: '10000',
        name: nameInput?.value || getSessionValue(SESSION_ID, 'name'),
        email: emailInput?.value || getSessionValue(SESSION_ID, 'email'),
        phone:
          stripPhone(phoneInput?.value) || getSessionValue(SESSION_ID, 'phone'),
        xxTrustedFormCertUrl,
      }

      const sessionCache = getFunnelCache(SESSION_ID) || {}
      const base64Param = leadDataToParam({ ...payload, ...sessionCache })
      const thanksUrl = `https://funnels.turbodebt.com/thanks/?params=${base64Param}`
      updateSession(SESSION_ID, 'thanksUrl', thanksUrl)
      initAbandonModal({
        element_id: 'onboardingSavingsv31Popup',
        cookie_name: 'onboardingSavingsv3-1ModalShown',
        modal_button_id: 'onboardingSavingsv3-1PopupButton',
        requiresURLParam: true,
        session_key: 'onboarding-v3-1-left-via-click',
        thresholdInSeconds: 15,
        check_for_onLeave: () => {
          return (
            document
              .querySelector('.onboarding-form-frame.active')
              ?.getAttribute('data-frame') === '1'
          )
        },
        modal_display_callback: () => {
          /** @type {HTMLElement | null} */
          const textNode = document.querySelector(
            '.o-sv3-1-popup-body .user_name',
          )
          /** @type {HTMLElement | null} */
          const parentContainer = document.querySelector(
            '.onboarding-container',
          )
          if (textNode) {
            textNode.innerText = getSessionValue(SESSION_ID, 'name')
          }

          if (parentContainer) {
            parentContainer?.setAttribute('inert', 'true')
            parentContainer.style.filter = 'blur(8px)'
          }
          return true
        },
        modal_close_callback: () => {
          /** @type {HTMLElement | null} */
          const parentContainer = document.querySelector(
            '.onboarding-container',
          )

          document
            .querySelector('.onboarding-container')
            ?.removeAttribute('inert')
          if (parentContainer) {
            parentContainer.style.filter = ''
          }
          return true
        },
      })

      try {
        submitSpinner(step3Button)

        // post name, email, & phone to middleware form-submit
        const redirectUrl = await submitForm(payload)

        // save chat link and go to next screen for credit pull
        updateSession(SESSION_ID, 'returnLink', redirectUrl)
      } catch (e) {
        console.error('error', e)
      } finally {
        resetSubmitSpinner(step3Button)
        transitionToFrame(2)
      }
    })
  }

  // Create frame transition function with loading frame callback
  const transitionToFrame = createFrameTransition(
    updateProgress,
    (/** @type {number} */ frame) => {
      // If transitioning to loading frame, trigger form submission
      if (frame === loadingFrameNumber) {
        //handleOnboardingSubmit()
        handleSoftpullSubmit()
      }
    },
  )

  // // Redirect to offerwall with current params
  // function redirectToOfferwall() {
  //   const currentParams = new URLSearchParams(window.location.search)
  //   currentParams.set('sub3', 'onboarding_3_1')
  //   currentParams.set('c1', 'eranwes')
  //   window.location.href = `https://funnels.turbodebt.com/offerwall/?${currentParams.toString()}`
  // }

  // /**
  //  * Set up option button handlers for a frame
  //  * @param {number} frameNumber - The frame number
  //  * @param {string} redirectValue - The value that triggers offerwall redirect
  //  * @param {number} nextFrame - The next frame to transition to
  //  */
  // function setupOptionButtons(frameNumber, redirectValue, nextFrame) {
  //   const buttons = document.querySelectorAll(
  //     `[data-frame="${frameNumber}"] .btn-option`,
  //   )

  //   buttons.forEach((button) => {
  //     button.addEventListener('click', (event) => {
  //       const btn = /** @type {HTMLButtonElement} */ (event.currentTarget)
  //       const value = btn.dataset.value

  //       if (value === redirectValue) {
  //         redirectToOfferwall()
  //         return
  //       }

  //       transitionToFrame(nextFrame)
  //     })
  //   })
  // }

  // // Set up option buttons for each qualifying question
  // setupOptionButtons(1, 'under7500', 2) // Amount Owed - Also added debt amount button class for GA event reporting
  // // setupOptionButtons(2, 'yes', 3) // Behind on Payments (COMMENTED OUT)
  // setupOptionButtons(2, 'no', 3) // Employment

  // Create frame submission handler - override with custom for this
  const handleFrameSubmit = createFrameSubmitHandlerNDR(
    transitionToFrame,
    null, // No OTP
    1, // Phone is on frame 1
    false, // useVeracity
    true, // No OTP
    true, // skip transition on frame 1
  )

  // Set up input listeners
  setupInputListeners()

  // Set up continue buttons
  setupContinueButtons(handleFrameSubmit)

  // Set up enter key listeners
  setupEnterKeyListeners(handleFrameSubmit)

  // Set up previous buttons
  setupPreviousButtons(transitionToFrame)

  // Set up sidebar toggle
  setupSidebarToggle(sidebar, sidebarTarget)

  // Set up disclaimer popup
  setupDisclaimerPopup()

  // Initialize progress
  updateProgress(1)
})
